import React from 'react'
import { GuestOrderConfig } from '@types'
import { BiPencil } from 'react-icons/bi'

type Props = {
  guestOrderConfig: GuestOrderConfig | null
  onRequestEdit: () => void
}

const defaultGuestOrderConfig = {
  maxOrdersPerGuest: 0,
  allowedEmailDomains: [],
  disableDeliveryNotifications: false,
}

const GuestOrderConfigSummary: React.FC<Props> = (props) => {
  const { onRequestEdit } = props
  const guestOrderConfig = props.guestOrderConfig || defaultGuestOrderConfig

  return (
    <div className="guest-order-config-summary">
      <div className="summary-header">
        <h3>Guest order configuration</h3>
        <div>
          <button onClick={onRequestEdit} className="edit-button">
            <div className="button-content">
              <BiPencil />
              <div>Edit</div>
            </div>
          </button>
        </div>
      </div>
      <div className="summary-description">
        <div className="summary-item">
          <div className="summary-label">Max orders per guest:</div>
          <div className="summary-value">
            {guestOrderConfig.maxOrdersPerGuest > 0
              ? guestOrderConfig.maxOrdersPerGuest
              : 'No limit'}
          </div>
        </div>

        <div className="summary-item">
          <div className="summary-label">Allowed email domains:</div>
          <div className="summary-value">
            {guestOrderConfig.allowedEmailDomains.length > 0
              ? guestOrderConfig.allowedEmailDomains.join(', ')
              : 'All email domains allowed'}
          </div>
        </div>

        <div className="summary-item">
          <div className="summary-label">Delivery notifications:</div>
          <div className="summary-value">
            {guestOrderConfig.disableDeliveryNotifications
              ? 'Disabled'
              : 'Enabled'}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GuestOrderConfigSummary
